import { FC } from 'react';
import { AsideMenu } from './AsideMenu';
import { CollapsedMenu } from './menu/CollapsedMenu';
import { PanelLeftClose, PanelLeft } from 'lucide-react';
import { useSidebar } from './menu/SidebarContext';

const AsideDefault: FC = () => {
  const { collapsed, setCollapsed, toggle } = useSidebar();

  return (
    <>
      <aside
        className={`
          fixed top-0 left-0 h-screen z-40
          border-r border-white/5
          flex flex-col
          transition-all duration-300 ease-out
          ${collapsed ? 'w-0 -translate-x-full lg:w-[72px] lg:translate-x-0' : 'w-[265px] translate-x-0'}
        `}
        style={{ backgroundColor: '#00335d' }}
        role="navigation"
        aria-label="Menu lateral principal"
      >
        <div className="flex items-center justify-between h-[60px] px-4 flex-shrink-0 pt-5">
          {!collapsed && (
            <div className="flex items-center overflow-hidden transition-opacity duration-200">
              <img
                src="https://interno.compra-agora.com/media/logos/logo-wide.png"
                alt="Compra Agora"
                className="h-14 object-contain"
              />
            </div>
          )}

          {collapsed && (
            <div className="hidden lg:flex items-center justify-center w-full">
              <button
                onClick={toggle}
                className="flex items-center justify-center w-10 h-10 rounded-xl hover:bg-white/10 transition-colors duration-200 cursor-pointer"
                aria-label="Expandir menu"
              >
                <img
                  src="https://interno.compra-agora.com/media/logos/logo-wide.png"
                  alt="Compra Agora"
                  className="h-6 w-10 object-contain"
                />
              </button>
            </div>
          )}

          {!collapsed && (
            <button
              onClick={toggle}
              className="flex items-center justify-center w-8 h-8 rounded-lg text-slate-300 hover:text-white hover:bg-white/10 transition-all duration-200 flex-shrink-0 cursor-pointer"
              aria-label="Recolher menu"
            >
              <PanelLeftClose size={18} />
            </button>
          )}
        </div>

        {collapsed ? (
          <div className="hidden lg:flex flex-1 overflow-y-auto overflow-x-hidden sidebar-scroll py-3">
            <CollapsedMenu />
          </div>
        ) : (
          <div className="flex-1 overflow-y-auto overflow-x-hidden sidebar-scroll">
            <AsideMenu />
          </div>
        )}
      </aside>

      {!collapsed && (
        <div
          className="fixed inset-0 bg-black/60 z-30 lg:hidden backdrop-blur-sm"
          onClick={() => setCollapsed(true)}
          aria-hidden="true"
        />
      )}

      <button
        onClick={() => setCollapsed(false)}
        className={`
          fixed top-4 left-4 z-50 lg:hidden
          flex items-center justify-center w-10 h-10 rounded-lg
          border border-white/10 text-slate-300
          hover:text-white hover:brightness-110
          transition-all duration-200 shadow-lg cursor-pointer
          ${!collapsed ? 'hidden' : ''}
        `}
        style={{ backgroundColor: '#00335d' }}
        aria-label="Abrir menu"
      >
        <PanelLeft size={20} />
      </button>
    </>
  );
};

export { AsideDefault };